import { message } from "antd";

export const uploadFilesIfNeeded = async (
  formValues,
  dynamicFormTemplate,
  dispatch,
  form,
  uploadDocumentCustomerDynamicFormAction
) => {
  const updatedValues = { ...formValues };
  const template =
    dynamicFormTemplate &&
    Array.isArray(dynamicFormTemplate) &&
    dynamicFormTemplate.length > 0
      ? dynamicFormTemplate[0]
      : null;

  if (!template?.questions) {
    return updatedValues;
  }

  const uploadPromises = [];

  template.questions.forEach((question, index) => {
    if (question.answerType === "file") {
      const fieldName = ["formQuestions", index];
      const answerValue =
        updatedValues?.formQuestions?.[index]?.answer ||
        updatedValues?.[`formQuestions[${index}].answer`];

      if (answerValue && Array.isArray(answerValue) && answerValue.length > 0) {
        const fileItem = answerValue[0];

        if (fileItem && !fileItem.url && !fileItem.publicId) {
          const fileToUpload = fileItem.originFileObj || fileItem;

          if (fileToUpload instanceof File) {
            uploadPromises.push(
              dispatch(uploadDocumentCustomerDynamicFormAction(fileToUpload))
                .then((uploadResult) => {
                  const uploadedFileInfo = {
                    url: uploadResult?.data?.url,
                    publicId: uploadResult?.data?.publicId,
                  };

                  if (uploadedFileInfo?.url || uploadedFileInfo?.publicId) {
                    if (!updatedValues.formQuestions) {
                      updatedValues.formQuestions = [];
                    }
                    if (!updatedValues.formQuestions[index]) {
                      updatedValues.formQuestions[index] = {
                        questionId: question._id,
                        answerType: question.answerType,
                        answer: [],
                      };
                    }

                    updatedValues.formQuestions[index].answer = [
                      {
                        ...fileItem,
                        url: uploadedFileInfo.url,
                        publicId: uploadedFileInfo.publicId,
                        status: "done",
                      },
                    ];

                    updatedValues[`formQuestions[${index}].answer`] =
                      updatedValues.formQuestions[index].answer;
                  }
                  return { index, uploadedFileInfo };
                })
                .catch((error) => {
                  throw error;
                })
            );
          }
        }
      }
    }
  });

  if (uploadPromises.length > 0) {
    message.loading({
      content: `Uploading ${uploadPromises.length} file(s)...`,
      key: "uploading",
      duration: 0,
    });

    try {
      await Promise.all(uploadPromises);
      message.success({
        content: "All files uploaded successfully",
        key: "uploading",
        duration: 2,
      });
    } catch (error) {
      message.error({
        content: "Failed to upload one or more files",
        key: "uploading",
        duration: 3,
      });
      throw error;
    }

    template.questions.forEach((question, index) => {
      if (question.answerType === "file") {
        const fieldPath = ["formQuestions", index, "answer"];
        const answerValue = updatedValues?.formQuestions?.[index]?.answer;
        if (answerValue) {
          form.setFieldValue(fieldPath, answerValue);
        }
      }
    });

    if (updatedValues.formQuestions) {
      form.setFieldValue("formQuestions", updatedValues.formQuestions);
    }
  }

  return updatedValues;
};
